module.exports = require("@swa-ui/core/src/InformationTipLegacy/InformationTipLegacy.module.scss");